export const getWorker = () => {
  if (typeof BUILD_HASH !== 'undefined') {
    return new Worker(`/worker.${BUILD_HASH}.js`);
  }

  return new Worker(`/worker.js`);
};
